import { createFileRoute } from "@tanstack/react-router";
import { ApiReferencePage } from "@/components/api-reference-page";
import {
  apiReferenceHead,
  apiReferenceMetaLoader,
} from "@/components/api-reference-meta";

export const Route = createFileRoute("/$locale/docs/api-reference")({
  loader: apiReferenceMetaLoader,
  head: apiReferenceHead,
  component: ApiReferencePage,
});
